import { useState } from 'react'
import { DSIHtml, Modal, useJsonApi } from 'shared'
import { DonateButton } from 'ppp'
import classNames from 'classnames'

import wirWunderLogo from '../../assets/images/logos/wirwunder_logo.svg'

export const MatchingEventNotice = (props) => {
  const [show, setShow] = useState(false)
  const onHide = () => setShow(false)

  const handleClick = () => {
    setShow(true)
    document.activeElement.blur()
  }

  const { data: matchingEvent } = useJsonApi(props.matchingEventUrl)
  if (!matchingEvent?.providedAmountInCents) return null

  return <div className='mb-3 p-3 rounded-lg' style={{ backgroundColor: matchingEvent.backgroundColor, color: matchingEvent.color }}>
    <div className='row'>
      <div className="col-8 flex items-center justify-center">
        <img src={matchingEvent.logo || wirWunderLogo} alt='' style={{ maxWidth: '90%', flexShrink: 0 }} />
      </div>
      <div className="col-16 pl-1" >
        <p className='mb-0'>
          <DSIHtml value={matchingEvent.bannerContent} />
          <br />
          <a onClick={handleClick} className="text-white hover:text-white font-regular text-underline">{I18n.t('projects.show.stats.matching_event.banner_read_more')}</a>
        </p>
      </div>
      <Modal
        show={show}
        onHide={onHide}
        content={
          <ModalContent
            matchingEvent={matchingEvent}
            project={props.project}
            status={props.status}
            onHide={onHide}
          />
        }
        header={matchingEvent.modalHeadline}
      />
    </div>
  </div>
}

const ModalContent = ({ matchingEvent, project, onHide, status }) => {
  const { backgroundColor, logo, modalDuration, modalBudget, modalMaximumAmount, modalFurtherInfo, branchLogo } = matchingEvent

  return <>
    <div className={classNames('flex text-center text-white items-center', logo ? 'justify-around' : 'justify-between')} style={{ backgroundColor: backgroundColor }}>
      <img className='ml-4 py-4 flex-grow-0 flex-shrink' src={logo || wirWunderLogo} alt='' style={{ maxHeight: '80px', maxWidth: '45%' }} />
      {!logo && <img className='mr-4 flex-grow-0 flex-shrink' src={branchLogo} alt='' style={{ maxHeight: '80px', maxWidth: '45%' }} />}
    </div>
    <div className='my-4'>
      <p>
        <DSIHtml value={modalDuration} />
      </p>
      <p>
        <DSIHtml value={modalBudget} />
      </p>
      <p>
        <DSIHtml value={modalMaximumAmount} />
      </p>
      <p className='my-6'>
        <DSIHtml value={modalFurtherInfo} />
      </p>
    </div>
    <div className='flex justify-between'>
      <button type="button" className="simulated-link" onClick={onHide} >{I18n.t('misc.close')}</button>
      {!project.donations_prohibited && <DonateButton
        project={project}
        status={status}
        additionalClass='btn-large'
        gaAction='click donate_button__matching_event'
      />}
    </div>
  </>
}
